import * as React from 'react';

import type {QuoteDisplayStatus} from 'nutshell-graphql-types';

import type {QuoteTimes} from '../../../../../../ui/lead/sales-documents/shared';

import {StackLegacy} from '../../layout/stack/stack-legacy';
import type {SalesDocumentType} from '../../lead-sidebar/sales-documents/types';

import {buildButtonConfig} from './helpers';
import {StatusLabel} from './status-label';

type Props = {
    quoteStatus: QuoteDisplayStatus;
    handleUpdateStatus: (status: QuoteDisplayStatus) => void;
    featureGated?: boolean;
    quoteTimes: QuoteTimes;
    type: SalesDocumentType;
};

export function StatusSection(props: Props) {
    const buttonConfig = buildButtonConfig(props.quoteStatus, props.handleUpdateStatus);

    return (
        <StackLegacy isHorizontal={true} spacing={12}>
            {buttonConfig.map((button) => (
                <StatusLabel
                    key={button.variant}
                    variant={button.variant}
                    quoteStatus={props.quoteStatus}
                    onAdvance={button.onAdvance}
                    isDisabled={
                        props.featureGated && button.variant !== 'DRAFT' ? true : button.disabled
                    }
                    featureGated={props.featureGated}
                    width={102}
                    height={32}
                    quoteTimes={props.quoteTimes}
                    type={props.type}
                />
            ))}
        </StackLegacy>
    );
}
